import {
    Themes,
    Test,
    Ticket
} from './index';

import {
    FaTags,
    FaListAlt,
    FaCubes,
} from "react-icons/fa";

export const authRole = {
    admin: 'admin',
    general_director: 'superAdmin'
};

export const samplePagesConfigs = [
    {
        key: 921,
        label: 'random_20',
        icon: <FaCubes className={'icon'} style={{ fontSize: 24, height: '100%' }} />,
        path: '/random/test?count=20',
        permittedRole: [authRole.admin],
        isBackground: true,
        sidebarOnly: true,
    },
    {
        key: 951,
        label: 'random_50',
        icon: <FaCubes className={'icon'} style={{ fontSize: 24, height: '100%' }} />,
        path: '/random/test?count=50',
        permittedRole: [authRole.admin],
        isBackground: true,
        sidebarOnly: true,
    },
    {
        key: 91,
        label: 'topic',
        icon: <FaTags className={'icon'} style={{ fontSize: 24, height: '100%' }} />, // Mavzular uchun teglarga mos ikona
        path: '/themes',
        element: Themes,
        permittedRole: [authRole.admin],
        isBackground: true
    },
    {
        key: 91213,
        label: 'ticket',
        icon: <FaListAlt className={'icon'} style={{ fontSize: 24, height: '100%' }} />, // Chiptalar uchun ro'yxatga o'xshash ikona
        path: '/ticket',
        element: Ticket,
        permittedRole: [authRole.admin],
        isBackground: true
    },
    {
        key: 9111232123,
        path: '/ticket/test',
        element: Test,
        permittedRole: [authRole.admin],
        isBackground: true,
        noIndex: true,
    },
    {
        key: 9111232,
        path: '/theme/test',
        element: Test,
        permittedRole: [authRole.admin],
        isBackground: true,
        noIndex: true,
    },
    {
        key: 911232,
        path: '/random/test',
        element: Test,
        permittedRole: [authRole.admin],
        isBackground: true,
        noIndex: true,
    },

];